import { SYNC_KEY_MARKETING_CAMPANAS } from "../../../constantes";
import { CampanaItem, MarketingPlataformaService } from "../../../shared/generated/grpc/plataforma_marketing_pb";
import {
  CampanaDetalleResponse,
  CampanaEstado,
  CampanaResponse,
  CampanaStatsResponse,
  CampanaTipo,
} from "../../../shared/response/marketing/CampanaResponse";
import { CampanaEstadoPayload } from "../../../shared/services/api/payload/marketing/CampanaEstadoPayload";
import { ServiceGetListBase } from "../../../shared/services/base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Campañas de marketing (`MarketingPlataformaService`, gRPC): listado en memoria, detalle, KPIs y estado. */
export class CampanaService extends ServiceGetListBase<CampanaResponse> {
  static readonly instance = new CampanaService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_MARKETING_CAMPANAS;

  /** gRPC-Web (`ListCampanas`): no eliminadas, de la más reciente a la más antigua. */
  protected async fetchItems(): Promise<CampanaResponse[]> {
    const r = await grpcCall(() => grpcClient(MarketingPlataformaService).listCampanas({}));
    return r.items.map(toCampanaResponse);
  }

  /** Campaña y sus contactos (registros de la landing). `NotFoundError` si no existe. */
  async getDetalle(id: string): Promise<CampanaDetalleResponse> {
    const r = await grpcCall(() => grpcClient(MarketingPlataformaService).getDetalle({ id }));
    if (!r.campana) throw new Error("Respuesta sin campaña");
    return {
      campana: toCampanaResponse(r.campana),
      contactos: r.contactos.map((c) => ({
        oportunidadId: c.oportunidadId,
        clienteId: c.clienteId,
        clienteNombre: c.clienteNombre,
        stage: c.stage,
        fechaRegistro: Number(c.fechaRegistro),
      })),
    };
  }

  /** Totales para los KPIs del listado. */
  async getStats(): Promise<CampanaStatsResponse> {
    const s = await grpcCall(() => grpcClient(MarketingPlataformaService).getStats({}));
    return {
      totalCampanas: s.totalCampanas,
      activas: s.activas,
      totalRegistros: s.totalRegistros,
      demosActivadas: s.demosActivadas,
    };
  }

  /** Cambia el estado y reemplaza la campaña en la lista en memoria. */
  async cambiarEstado(id: string, payload: CampanaEstadoPayload): Promise<CampanaResponse> {
    const r = await grpcCall(() => grpcClient(MarketingPlataformaService).cambiarEstado({ id, estado: payload.estado }));
    const item = toCampanaResponse(r);
    this.upsert(item);
    return item;
  }
}

/** Mensaje gRPC de la campaña → `CampanaResponse`. Lo reusa el guardado. */
export function toCampanaResponse(c: CampanaItem): CampanaResponse {
  return {
    id: c.id,
    isEliminado: false,
    nombre: c.nombre,
    tipo: c.tipo as CampanaTipo,
    objetivo: c.objetivo,
    codigo: c.codigo ?? null,
    cuposMaximos: c.cuposMaximos,
    cuposUsados: c.cuposUsados,
    fechaLimite: c.fechaLimite !== undefined ? new Date(Number(c.fechaLimite)).toISOString() : null,
    urlLanding: c.urlLanding ?? null,
    activaDemo: c.activaDemo,
    estado: c.estado as CampanaEstado,
    mensajeTemplate: c.mensajeTemplate ?? null,
  };
}
